import { Dispatch, SetStateAction, useRef, useState } from 'react';
import ReactDOM from 'react-dom';

import { useOutside } from 'hooks/UseOutside';

import { Button } from '../../atoms/Button/Button';

import { ModalCloseButton } from '../SendDocumentsModal/_sendDocumentsModal';

import { Container, ModalContainer } from './_difficultyPriceModal';

interface IServiceTypeDifficulty {
  id: number;
  name: string;
  default_price: number;
  difficulty: number;

  formattedDefaultPrice: string;
}

interface IDifficultyPriceModalProps {
  toggleModal: Dispatch<SetStateAction<boolean>>;
  callback?: () => void;
  difficulty: IServiceTypeDifficulty;
  serviceName: string;
  onConfirm: (difficulty: IServiceTypeDifficulty, price: number) => void;
}

export const DifficultyPriceModal = ({ toggleModal, callback, difficulty, serviceName, onConfirm }: IDifficultyPriceModalProps) => {
  const modalRoot = document.getElementById('root-modal');
  const modalRef = useRef(null);

  const [hideModal, setHideModal] = useState(false);
  const [newPrice, setNewPrice] = useState((difficulty.default_price / 100).toString());

  const handleCloseModal = () => {
    setHideModal((prevState) => !prevState);

    setTimeout(() => {
      toggleModal((prevState) => !prevState);
    }, 500);
  }

  const handleNewPriceChange = (text: string) => {
    setNewPrice(text);
  }

  const handleConfirm = () => {
    setHideModal((prevState) => !prevState);
    onConfirm(difficulty, parseFloat(newPrice));

    setTimeout(() => {
      toggleModal((prevState) => !prevState);
    }, 500);
  }

  useOutside(modalRef, handleCloseModal);

  if (!modalRoot) {
    return null;
  }

  return ReactDOM.createPortal(
    <Container className={`${hideModal ? 'modal-difficulty-price--hide' : ''}`}>
      <ModalContainer ref={modalRef}>
        <ModalCloseButton type="button" onClick={handleCloseModal}>X</ModalCloseButton>
        <h1 className="modal-difficulty-price__title">
          {serviceName}
          <br />
          {difficulty.name}
        </h1>
        <h2 className="modal-difficulty-price__question">Quanto você quer cobrar por esse serviço?</h2>

        <div className="modal-difficulty-price__prefix-input-container">
          <span className="modal-difficulty-price__currency-prefix">
            R$
          </span>
          <input
            type="number"
            value={newPrice}
            onChange={(e) => handleNewPriceChange(e.target.value)}
            className="modal-difficulty-price__input"
            step="0.01"
          />
        </div>

        <Button onClick={handleConfirm} className="button modal-difficulty-price__button">
          Salvar alteração
        </Button>
      </ModalContainer>
    </Container>,
    modalRoot
  )
}
